import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { SBreadcrumbs } from '@avalara/skylab-sdk/react';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { Link } from 'react-router-dom';
import { userIdentityLinkTo } from '../../utils/userIdentityRoutes';

const ALL_COMPANIES_GRANT = '*';

export const ViewUserDetails = (props) => {
    let userId = props?.location?.state?.userId;
    let user = props?.users?.find(obj => obj.id === userId);

    useEffect(() => {
        if (!props.users || !userId) {
            props.history.push('/UserManagement');
        }
    }, [props.users, props.history, userId]);

    let currentProfile = `${user?.firstName} ${user?.lastName} ${LANGUAGES_CONTROLLER.format(props.languages, "UserManagementProfileText")}`;

    const breadcrumbItems = [{
        label: LANGUAGES_CONTROLLER.format(props.languages, "UserManagementUsersBreadcrumbLink"),
        dataRef: "1",
        emitNavEvent: true
    },
    {
        label: currentProfile,
        dataRef: "2"
    }
    ];

    const companiesRows = () => {
        if (user?.companyGrants?.length > 0) {
            if (user.companyGrants.includes(ALL_COMPANIES_GRANT)) {
                return <span data-testid="user-company-value">{LANGUAGES_CONTROLLER.format(props.languages, "UserManagementAllCompaniesText")}<br /></span>
            }
            return user.companyGrants.map(companyId => {
                return (
                    <span data-testid="user-company-value">{props.companiesLookup[companyId]}<br /></span>
                );
            });
        }
        else {
            return null;
        }
    }

    const userDetails = () => {
        if (user) {
            return <table>
                <tr>
                    <th data-testid="user-firstname-column"><LanguageStringResolver className="float-left" string='UserManagementUserFirstName' /></th>
                    <th data-testid="user-lastname-column"><LanguageStringResolver className="float-left" string='UserManagementUserLastName' /></th>
                    <th data-testid="user-email-column"><LanguageStringResolver className="float-left" string='UserManagementUserEmail' /></th>
                </tr>
                <tr className="vertical-align-top">
                    <td>{user.firstName}</td>
                    <td>{user.lastName}</td>
                    <td>{user.id}</td>
                </tr>
            </table>
        }
    }

    const handleNavClick = () => props.history.push('/UserManagement');

    const companies = companiesRows();
    const userTable = userDetails();
    const linkToUrl = userIdentityLinkTo('/EditUser', user?.id);

    return (
        <div className="content-area">
            {user &&
                <s-container data-testid="view-user-details">
                    <SBreadcrumbs data-testid="navigation-breadcrumbs" navItems={breadcrumbItems} navHandler={handleNavClick}></SBreadcrumbs>
                    <h1 className="mb0 mt0">{`${user.firstName} ${user.lastName}`}</h1>
                    <span data-testid="user-profile-heading"><LanguageStringResolver string='UserManagementUserProfile' /></span>
                    <hr data-testid="horizontal-rule-one" />
                    <h3 className="mb0" data-testid="user-details-heading"><LanguageStringResolver string='UserManagementUserDeatils' /></h3>
                    {userTable}
                    <h3 className="mb0" data-testid="user-companies-heading"><LanguageStringResolver string='UserManagementCompanies' /></h3>
                    {companies}
                    <h3 className="mb0" data-testid="access-control-heading"><LanguageStringResolver string='UserManagementAccessControl' /></h3>
                    {user.role}
                    <hr data-testid="horizontal-rule-two" />
                    <Link className="button primary float-left" to={linkToUrl} data-testid="user-edit-button">
                        <LanguageStringResolver string='UserManagementEdit' />
                    </Link>
                </s-container>
            }
        </div>
    );
};

export function mapStateToProps(state) {
    return {
        users: state.userManagement?.data,
        companiesLookup: state.userManagement?.companiesLookup,
        languages: state.languages  // Add this line
    };
}

export default connect(mapStateToProps)(ViewUserDetails);
